//import { baseURL } from '@/config'
const baseURL = window.baseURL
const UIMSUrl = baseURL.Gateway + 'uims/api/'
const SalesUrl = baseURL.Gateway + 'sales/api/'
const FileServer = baseURL.Gateway + 'fileserver/api/'
const PortalUrl = baseURL.Gateway + 'portal/api/'
const FileHost = baseURL.FileHost
const MarketinglUrl = baseURL.Gateway + 'marketing/api/'
const ServiceUrl = baseURL.Gateway + 'service/api/'
const LogUrl = baseURL.Gateway + 'log/api/'
const FinanceUrl = baseURL.Gateway + 'finance/api/'
const ManagerUrl = baseURL.Gateway + 'manager/api/'

const api = {}

api.defaultTenant = 'zeyu'
api.H5Host = baseURL.H5Host
api.UploadImage = FileServer + 'File/UploadImage'
api.UploadVideo = FileServer + 'File/UploadVideo'
api.UploadAudio = FileServer + 'File/UploadAudio'
api.FileHost = FileHost

api.LogAppend = LogUrl + 'Log/Append'
// namespaced: user
api.GetTenantByCode = UIMSUrl + 'Tenant/GetTenantByCode'
api.TenantAvailable = UIMSUrl + 'Tenant/Available'
api.TenantRegister = UIMSUrl + 'Tenant/Register'
api.TenantApply = UIMSUrl + 'Tenant/Apply'
api.TenantGetListByOwner = UIMSUrl + 'Tenant/GetListByOwner'
api.StaffRegister = UIMSUrl + 'Staff/Register' //注册为当前租户职员
api.StaffGetStaffsByStaffIds = UIMSUrl + 'Staff/GetStaffsByStaffIds' //判断是不是职员

api.login = UIMSUrl + 'User/Login'
api.GetUserInfo = UIMSUrl + 'User/GetUserInfo'
api.GetCurrentUserInfo = UIMSUrl + 'User/GetCurrentUserInfo'
api.GetUserInfoByAccount = UIMSUrl + 'User/GetUserInfoByAccount' //根据account 查找用户
api.GetUserList = UIMSUrl + 'User/GetUserList'
api.GetMyAgreements = SalesUrl + 'Form/GetMyAgreements'
api.VisitTenant = UIMSUrl + 'TenantVisit/VisitTenant'

// namespaced: user
api.WechatGetOpenAppID = UIMSUrl + 'Wechat/GetOpenAppID'
api.WechatLogin = UIMSUrl + 'Wechat/Login'

api.UserAddByWX = UIMSUrl + 'User/AddByWX' //添加一个微信 unionId 用户
api.UserWxLogin = UIMSUrl + 'User/WxLogin' //用微信ID登录
api.WechatGetJSSdkInfo = UIMSUrl + 'Wechat/GetJSSdkInfo'
// api.StaffRegister = UIMSUrl + 'Staff/Register' // 注册用户绑定租户
// api.StaffDeregister = UIMSUrl + 'Staff/Deregister' // 注册用户解绑租户
// api.QueryStaffList = UIMSUrl + 'Staff/QueryStaffList' // 租户下用户列表
// api.StaffRoleGetRightList = SalesUrl + 'StaffRole/GetRightList' // 查找租户下用户列表对应的role
api.UserRegister = UIMSUrl + 'User/Register' // 注册用户
api.UserUpdateAvatar = UIMSUrl + 'User/UpdateAvatar' // 更新用户头像
api.UserUpdateUserInfo = UIMSUrl + 'User/UpdateUserInfo'
api.VerfiyAccount4SendVerificationCode =
  UIMSUrl + 'User/VerfiyAccount4SendVerificationCode'
api.ResetPassword = UIMSUrl + 'User/ResetPassword'
api.SendVerificationCode = UIMSUrl + 'Verification/SendVerificationCode'
api.VerificateCode = UIMSUrl + 'Verification/VerificateCode'

api.WechatGetAppID = UIMSUrl + 'Wechat/GetAppID'
api.WechatAuthor = UIMSUrl + 'Wechat/Author'
api.GetWechatOpenId = UIMSUrl + 'Wechat/GetWechatOpenId' //微信静默授权获取OpenId

api.PostPublish = PortalUrl + 'Post/Publish'
api.PostDelete = PortalUrl + 'Post/DeleteByAuthor'
api.PostUpdate = PortalUrl + 'Post/Update'
api.PostGet = PortalUrl + 'Post/Get'
api.PostSelectByIdList = PortalUrl + 'Post/SelectByIdList'
api.PostSelectMyPost = PortalUrl + 'Post/SelectMyPost'
api.PostSelectByTenant = PortalUrl + 'Post/SelectByTenant'
api.PostSelectByTopic = PortalUrl + 'Post/SelectByTopic'
api.PostSelectByAuthor = PortalUrl + 'Post/SelectByAuthor'
api.PostSearch = PortalUrl + 'Post/Search'
api.TopicTagGetList = PortalUrl + 'TopicTag/GetList'
api.TopicTagGetByIds = PortalUrl + 'TopicTag/GetByIds'
api.GetBatchArticleStatistics =
  PortalUrl + 'ArticleOperation/GetBatchArticleStatistics'
api.GetArticlesByAction = PortalUrl + 'ArticleOperation/GetArticlesByAction'
api.ArticleOperationCancel =
  PortalUrl + 'ArticleOperation/ArticleOperationCancel'
api.ArticleOperationIncrease =
  PortalUrl + 'ArticleOperation/ArticleOperationIncrease'

// api.SurveyGetDetails = SalesUrl + 'Survey/GetDetails' // 查询问卷下的所有题干
// api.SurveyResultStart = SalesUrl + 'SurveyResult/Start' //开始答题
// api.SurveyResultComplete = SalesUrl + 'SurveyResult/Complete' //结束答题
// api.SurveyAnswerAdd = SalesUrl + 'SurveyAnswer/Answer' //答题
// api.SurveyAnswerAnswerList = SalesUrl + 'SurveyAnswer/AnswerList' //答题
// api.SurveyAnswerModify = SalesUrl + 'SurveyAnswer/Modify' // 修改答案
// api.FormQueryFormSurvey = SalesUrl + 'Form/QueryFormSurvey' //查询工单对应的答卷详情

// // SalesUrl
// api.WorkflowStart = SalesUrl + 'Workflow/Start'
// api.WorkflowAdvancedApply = SalesUrl + 'Workflow/AdvancedApply' //二次咨询单
// api.WorkflowAgreement = SalesUrl + 'Workflow/Agreement' // 用户签署协议
api.ProductAgreementGetAgreement = SalesUrl + 'ProductAgreement/GetAgreement' //获取产品的协议内容

api.FormGetAgreementWithSignatureInfo =
  ServiceUrl + 'Form/GetAgreementWithSignatureInfo' //获取产品协议和用户签署信息

api.IndustryGetAll = UIMSUrl + 'Industry/GetAll' //获取所有有效的行业定义
api.ChannelApply = MarketinglUrl + 'Channel/Apply' // 申请成为渠道
api.GetChannel = MarketinglUrl + 'Channel/GetChannel' // 获取渠道详情
api.OrderGetChannelOrder = SalesUrl + 'Order/GetChannelOrder' //
api.GetOrderStatistics = SalesUrl + 'Order/GetOrderStatistics' //
api.GetChannelOrderTotal = SalesUrl + 'Order/GetChannelOrderTotal' //
api.GetMarketingAll = SalesUrl + 'SurveyDispatch/GetMarketingAll' //
api.GetProductWorkflow = SalesUrl + 'WorkflowSetting/GetProductWorkflow' //获取产品的销售流程code列表

api.GetPackagePageListByMarketingChannelId =
  ServiceUrl + 'Package/GetPackagePageListByMarketingChannelId'
api.PackageGetPackageDetailList = ServiceUrl + 'Package/GetPackageDetailList'
api.PackageReceive = ServiceUrl + 'Package/ReceiveCoupon' // 学员领取服务包
api.PackageGet = ServiceUrl + 'Package/Get'
api.GetPackageByDetailId = ServiceUrl + 'Package/GetPackageByDetailId'
api.PackageGetPackageInfoBeforeReceive =
  ServiceUrl + 'Package/GetPackageInfoBeforeReceive'

api.PackageReceiveCoupon = ServiceUrl + 'Package/ReceiveCoupon' // 领取优惠券（新版）
api.PackageUseCoupon = ServiceUrl + 'Package/UseCoupon' //使用优惠券生成服务计划订单

// api.ReceiveWithCreatePaymentOrder =
//   ServiceUrl + 'Package/ReceiveWithCreatePaymentOrder'

// 微信支付
api.GetPaymentOrderForSettlement =
  FinanceUrl + 'PaymentTransaction/GetPaymentOrderForSettlement' // 查询待支付产品信息
api.SalesWorkFlowJsapiPayment = SalesUrl + 'Payment/SalesWorkFlowJsapiPayment' //唤起微信支付jssdk
api.QueryTransactionStatus =
  FinanceUrl + 'PaymentTransaction/QueryTransactionStatus' // 查询支付状态
api.PackageJsapiPayment = ServiceUrl + 'Package/PackageJsapiPayment' // 优惠券唤起支付
api.FormJsapiPayment = ServiceUrl + 'Form/FormJsapiPayment' //服务计划购买唤起支付

api.FormGetFormOrderCoupon = ServiceUrl + 'Form/GetFormOrderCoupon' //获取订单的优惠券

api.FormSignAgreement = ServiceUrl + 'Form/SignAgreement' //签署协议

//ManagerUrl
api.GetAgreementInfo = ManagerUrl + 'SettingCenter/GetAgreementInfo'

export default api
